import { render, staticRenderFns } from "./FamilyBlock.vue?vue&type=template&id=60e3d1f3&"
import script from "./FamilyBlock.vue?vue&type=script&lang=js&"
export * from "./FamilyBlock.vue?vue&type=script&lang=js&"
import style0 from "./FamilyBlock.vue?vue&type=style&index=0&id=60e3d1f3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports